import {
  SET_SEARCHOPTIONS_VIEW,
  SET_SHOW_SEARCH_OPTIONS,
  SET_MODULES,
  SearchOptionsViewTypes,
} from "./actions";

interface SearchOptionsView {
  view: string;
  showSearchOptions: boolean;
}

const initialState: SearchOptionsView = {
  view: "destinations",
  showSearchOptions: true,
};

const SearchOptionsViewReducer = (
  state = initialState,
  action: SearchOptionsViewTypes
) => {
  switch (action.type) {
    case SET_SEARCHOPTIONS_VIEW:
      return { ...state, view: action.payload };
    case SET_SHOW_SEARCH_OPTIONS:
      return { ...state, showSearchOptions: action.payload };
    default:
      return state;
  }
};

export const ModulesReducer = (
  state = { modules: [] },
  action: SearchOptionsViewTypes
) => {
  switch (action.type) {
    case SET_MODULES:
      return { ...state, modules: action.payload };
    default:
      return state;
  }
};

export default SearchOptionsViewReducer;
